import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CoachingApp from "@/pages/CoachingApp";
import AdminPage from "@/pages/AdminPage";
import SettingsPage from "@/pages/SettingsPage";
import SharedReport from "@/pages/SharedReport";
import { LanguageProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App dark">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<CoachingApp />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/r/:token" element={<SharedReport />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="light" richColors />
      </LanguageProvider>
    </div>
  );
}

export default App;
